import { tagColors } from '@/components/tag/tag-colors'
export const FbaShipmentEnum = {
  status: {
    /**
     * 卖家已创建货件，但未发货
     */
    WORKING: 'WORKING',
    /**
     * 卖家已创建货件，准备出货
     */
     READY_TO_SHIP: 'READY_TO_SHIP',

    /**
     * 承运人已取件
     */
    SHIPPED: 'SHIPPED',
    /**
     * 承运人已通知亚马逊运营中心其已知晓货件的存在
     */
    IN_TRANSIT: 'IN_TRANSIT',
    /**
     * 承运人已将货件配送至亚马逊运营中心
     */
    DELIVERED: 'DELIVERED',
    /**
     * 货件已在亚马逊运营中心的收货装卸地点登记
     */
    CHECKED_IN: 'CHECKED_IN',
    /**
     * 货件已到达亚马逊运营中心，但有部分商品尚未标记为已收到
     */
    RECEIVING: 'RECEIVING',
    /**
     * 货件已到达亚马逊运营中心，且所有商品已经标记为已收到。
     */
    CLOSED: 'CLOSED',
    /**
     * 卖家在货件发亚马逊运营中心后取消了货件
     */
    CANCELLED: 'CANCELLED',
    /**
     * 卖家在将货件发送到亚马逊运营中心之前取消了货件
     */
    DELETED: 'DELETED',
    /**
     * 货件出错，但不是由亚马逊处理的
     */
    ERROR: 'ERROR'
  },
  statusOption: [
    /**
     * 卖家已创建货件，但未发货
     */
    { id: 'WORKING', text: 'WORKING', ...tagColors.blue},
       /**
   * 卖家已创建货件，准备出货
   */
  { id: 'READY_TO_SHIP', text: 'READY_TO_SHIP', ...tagColors.blue},

  /**
   * 承运人已取件
   */
    { id: 'SHIPPED', text: 'SHIPPED', ...tagColors.green},
  /**
   * 承运人已通知亚马逊运营中心其已知晓货件的存在
   */
    { id: 'IN_TRANSIT', text: 'IN_TRANSIT', ...tagColors.blue},
  /**
   * 承运人已将货件配送至亚马逊运营中心
   */
    { id: 'DELIVERED', text: 'DELIVERED', ...tagColors.green},
  /**
   * 货件已在亚马逊运营中心的收货装卸地点登记
   */
    { id: 'CHECKED_IN', text: 'CHECKED_IN', ...tagColors.green},
  /**
   * 货件已到达亚马逊运营中心，但有部分商品尚未标记为已收到
   */
    { id: 'RECEIVING', text: 'RECEIVING', ...tagColors.blue},
  /**
   * 货件已到达亚马逊运营中心，且所有商品已经标记为已收到。
   */
    { id: 'CLOSED', text: 'CLOSED', ...tagColors.lightGray},
  /**
   * 卖家在货件发亚马逊运营中心后取消了货件
   */
    { id: 'CANCELLED', text: 'CANCELLED', ...tagColors.gray},
  /**
   * 卖家在将货件发送到亚马逊运营中心之前取消了货件
   */
    { id: 'DELETED', text: 'DELETED', ...tagColors.gray},
  /**
   * 货件出错，但不是由亚马逊处理的
   */
    {id: 'ERROR', text: 'ERROR', ...tagColors.red}
  ],
  fbaTransport: {
    NOT_UPLOADED: 'NOT_UPLOADED',
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
  },
  fbaTransportOption: [
    {id: 'NOT_UPLOADED', text: '未上传'},
    {id: 'UPLOAD_SUCCESS', text: '上传成功'},
  ],
  fbaPackage: {
    NOT_UPLOADED: 'NOT_UPLOADED',
    UPLOADING: 'UPLOADING',
    UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
    UPLOAD_FAILED: 'UPLOAD_FAILED',
  },
  fbaPackageOption: [
    {id: 'NOT_UPLOADED', text: '未上传'},
    {id: 'UPLOADING', text: '上传中'},
    {id: 'UPLOAD_SUCCESS', text: '上传成功'},
    {id: 'UPLOAD_FAILED', text: '上传失败'}
  ],
  listFbaPackageOption: [
    {id: 'NOT_UPLOADED', text: '未上传', color: '#606266'},
    {id: 'UPLOADING', text: '上传中...', color: '#5986FB'},
    {id: 'UPLOAD_SUCCESS', text: '上传成功', color: '#1F6EEF'},
    {id: 'UPLOAD_FAILED', text: '上传失败', color: 'red'}
  ],
  // 预览货件
  preview_labelPrepType: {
    SELLER_LABEL: 'SELLER_LABEL',
    AMAZON_LABEL_ONLY: 'AMAZON_LABEL_ONLY'
  },
  preview_labelPrepTypeOption: [
    {id: 'SELLER_LABEL', text: '卖家'},
    {id: 'AMAZON_LABEL_ONLY', text: '亚马逊'},
  ],
  // 页面展示
  list_labelPrepType: {
    SELLER_LABEL: 'SELLER_LABEL',
    AMAZON_LABEL: 'AMAZON_LABEL'
  },
  list_labelPrepTypeOption: [
    {id: 'SELLER_LABEL', text: '卖家'},
    {id: 'AMAZON_LABEL', text: '亚马逊'},
  ],
  // 包装类型
  areCasesRequired: {
    MIX: false,
    ORIGIN: true,
  },
  areCasesRequiredOption: [
    {id: false, text: '混装'},
    {id: true, text: '原厂包装'},
  ],
  transferSlipOption:[
    {id: true, text: '是'},
    {id: false, text: '否'},
  ],
  associatedGoodsOption:[
    {id: true, text: '是'},
    {id: false, text: '否'},
  ],
  shipmentType: {
    SPD: 'SP',
    LTL: 'LTL',
  },
  shipmentTypeOption: [
    {id: 'SP', text: '小包裹快递(SPD)'},
    {id: 'LTL', text: '零担货运(LTL)'}
  ]
};


















